module.exports = __webpack_public_path__ + "static/media/15.6c389b74.png";